import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { addToTitanSpineSlot, resetTitanSpine, updateResponsiveSpineSlotsChildren } from "../../../utils/SpineUtils";
import { Graphics, Texture } from "pixi.js";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { MouseUtil } from "@lib/titan2/dist/util/view/MouseUtil";
import { SoundEvent } from "../../../controller/event/GameEvent";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { GameLang } from "../lang/GameLang";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
var INTRO;
(function (INTRO) {
    INTRO["WIN"] = "MEOW intro";
    INTRO["BIGWIN"] = "PAWSOME intro";
    INTRO["SUPERBIGWIN"] = "PURRRFECT intro";
    INTRO["MEGAWIN"] = "AMEOWZING intro";
})(INTRO || (INTRO = {}));
var INTRO_TRANSLATED;
(function (INTRO_TRANSLATED) {
    INTRO_TRANSLATED["WIN"] = "meowTranslated-intro";
    INTRO_TRANSLATED["BIGWIN"] = "pawsomeTranslated-intro";
    INTRO_TRANSLATED["SUPERBIGWIN"] = "purrrfectTranslated-intro";
    INTRO_TRANSLATED["MEGAWIN"] = "ameowzingTranslated-intro";
})(INTRO_TRANSLATED || (INTRO_TRANSLATED = {}));
var IDLE;
(function (IDLE) {
    IDLE["WIN"] = "MEOW loop";
    IDLE["BIGWIN"] = "PAWSOME loop";
    IDLE["SUPERBIGWIN"] = "PURRRFECT loop";
    IDLE["MEGAWIN"] = "AMEOWZING loop";
})(IDLE || (IDLE = {}));
var IDLE_TRANSLATED;
(function (IDLE_TRANSLATED) {
    IDLE_TRANSLATED["WIN"] = "meowTranslated-loop";
    IDLE_TRANSLATED["BIGWIN"] = "pawsomeTranslated-loop";
    IDLE_TRANSLATED["SUPERBIGWIN"] = "purrrfectTranslated-loop";
    IDLE_TRANSLATED["MEGAWIN"] = "ameowzingTranslated-loop";
})(IDLE_TRANSLATED || (IDLE_TRANSLATED = {}));
var OUTRO;
(function (OUTRO) {
    OUTRO["WIN"] = "MEOW outro";
    OUTRO["BIGWIN"] = "PAWSOME outro";
    OUTRO["SUPERBIGWIN"] = "PURRRFECT outro";
    OUTRO["MEGAWIN"] = "AMEOWZING outro";
})(OUTRO || (OUTRO = {}));
var OUTRO_TRANSLATED;
(function (OUTRO_TRANSLATED) {
    OUTRO_TRANSLATED["WIN"] = "meowTranslated-outro";
    OUTRO_TRANSLATED["BIGWIN"] = "pawsomeTranslated-outro";
    OUTRO_TRANSLATED["SUPERBIGWIN"] = "purrrfectTranslated-outro";
    OUTRO_TRANSLATED["MEGAWIN"] = "ameowzingTranslated-outro";
})(OUTRO_TRANSLATED || (OUTRO_TRANSLATED = {}));
const THRESHOLDS = [0, 20, 50, 100];
const THRESHOLD_INDEX_TO_ENUM = ["WIN", "BIGWIN", "SUPERBIGWIN", "MEGAWIN"];
export class GameBigWin extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    create() {
        super.create();
        this.backgroundShade = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.6));
        this.addChild(this.backgroundShade);
        this.backgroundShade.visible = false;
        this.lightBurst = TitanSpine.createSpine(this, "lightBurst", this.landscapeProperties.lightBurstProperties, this.portraitProperties?.lightBurstProperties);
        this.animation = TitanSpine.createSpine(this, this.landscapeProperties.animation, this.portraitProperties.animation);
        this.value = TitanText.createField(this, "big-win-value", this.landscapeProperties.value, this.portraitProperties.value);
        this.value.setText("", true);
        this.value.pivot.y = this.value.getHeight() / 2;
        this.animation.visible = false;
        this.animation.name = "bigwin";
        this.lightBurst.visible = false;
        if (this.shouldLocalise()) {
            const titleWin = TitanText.createField(this, "big-win-title", this.landscapeProperties.titleWin, this.portraitProperties.titleWin);
            titleWin.pivot.y = titleWin.getHeight() / 2;
            titleWin.visible = false;
            addToTitanSpineSlot(this.animation, titleWin, "dynamic-text-base");
            titleWin.setText(this.langManager.getLang(GameLang.BIG_WIN_1).toUpperCase(), true);
            const titleBigWin = TitanText.createField(this, "big-win-title", this.landscapeProperties.titleBigWin, this.portraitProperties.titleBigWin);
            titleBigWin.pivot.y = titleBigWin.getHeight() / 2;
            titleBigWin.visible = false;
            addToTitanSpineSlot(this.animation, titleBigWin, "dynamic-text-base");
            titleBigWin.setText([this.langManager.getLang(GameLang.BIG_WIN_0), this.langManager.getLang(GameLang.BIG_WIN_1)].join(" ").toUpperCase(), true);
            const localisedTitleSuperBigWin = TitanText.createField(this, "super-big-win-title", this.landscapeProperties.titleSuperBigWin, this.portraitProperties.titleSuperBigWin);
            localisedTitleSuperBigWin.pivot.y = localisedTitleSuperBigWin.getHeight() / 2;
            localisedTitleSuperBigWin.visible = false;
            addToTitanSpineSlot(this.animation, localisedTitleSuperBigWin, "dynamic-text-base");
            localisedTitleSuperBigWin.setText([this.langManager.getLang(GameLang.HUGE_WIN_0), this.langManager.getLang(GameLang.BIG_WIN_1)].join(" ").toUpperCase(), true);
            const localisedTitleMegaWin = TitanText.createField(this, "mega-win-title", this.landscapeProperties.titleMegaWin, this.portraitProperties.titleMegaWin);
            localisedTitleMegaWin.pivot.y = localisedTitleMegaWin.getHeight() / 2;
            localisedTitleMegaWin.visible = false;
            addToTitanSpineSlot(this.animation, localisedTitleMegaWin, "dynamic-text-base");
            localisedTitleMegaWin.setText([this.langManager.getLang(GameLang.MEGA_WIN_0), this.langManager.getLang(GameLang.BIG_WIN_1)].join(" ").toUpperCase(), true);
            this.localisedTitle = {
                WIN: titleWin,
                BIGWIN: titleBigWin,
                SUPERBIGWIN: localisedTitleSuperBigWin,
                MEGAWIN: localisedTitleMegaWin,
            };
        }
    }
    createRectangleTexture(width, height, colour, alpha) {
        const graphics = new Graphics();
        graphics.beginFill(colour, alpha);
        graphics.drawRect(0, 0, width, height);
        return Texture.from(this.renderer.getRenderer().generateTexture(graphics, { resolution: 1 }).baseTexture);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameBigWinEvents.PLAY, this.play);
    }
    play() {
        this.backgroundShade.fitToWindow();
        const win = this.model.getTotalWin();
        const stake = this.model.getTotalStaked();
        resetTitanSpine(this.animation);
        this.value.setText("", true);
        const thresholdValues = this.getThresholdValues(win, stake);
        const timeline = gsap.timeline();
        this.backgroundShade.alpha = 0;
        this.backgroundShade.visible = true;
        timeline.add(() => {
            gsap.to(this.backgroundShade, { duration: 0.5, alpha: 1 });
        });
        let currentValue = 0;
        thresholdValues.forEach((thresholdValue, thresholdIndex, activeThresholds) => {
            const isLastThreshold = thresholdIndex === activeThresholds.length - 1;
            const isFirstThreshold = thresholdIndex === 0;
            const intro = this.shouldLocalise() ? INTRO_TRANSLATED[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]] : INTRO[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]];
            const idle = this.shouldLocalise() ? IDLE_TRANSLATED[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]] : IDLE[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]];
            const outro = this.shouldLocalise() ? OUTRO_TRANSLATED[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]] : OUTRO[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]];
            timeline.add(() => {
                if (thresholdIndex === 0) {
                    this.revealValue();
                }
                resetTitanSpine(this.animation);
                if (this.shouldLocalise()) {
                    Object.values(this.localisedTitle).forEach(title => title.visible = false);
                    this.localisedTitle[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]].visible = true;
                }
                this.dispatchGame(SoundEvent.BIG_WIN_THRESHOLD);
                SpineUtil.play(this.animation, intro, () => {
                    SpineUtil.playLoop(this.animation, idle);
                }, null, 0);
                this.animation.visible = true;
            });
            let toValue = null;
            if (isLastThreshold) {
                toValue = win;
            }
            else {
                toValue = this.getThresholdIndexValue(win, stake, thresholdIndex + 1);
            }
            if (thresholdIndex === 0) {
                timeline.add(() => this.dispatchGame(SoundEvent.BIG_WIN_START));
            }
            this.addCountupTween(timeline, currentValue, toValue);
            currentValue = toValue;
            if (isLastThreshold) {
                this.addHoldAndHide(timeline, outro);
                MouseUtil.setInteractive(this.backgroundShade, !Service.isReplay());
                const localisedTitle = this.shouldLocalise() ? this.localisedTitle[THRESHOLD_INDEX_TO_ENUM[thresholdIndex]] : null;
                if (this.clickHandler !== undefined) {
                    MouseUtil.removeMouseDown(this.backgroundShade, this.clickHandler);
                    this.clickHandler = undefined;
                }
                this.clickHandler = () => this.handleClick(intro, idle, outro, win, localisedTitle);
                MouseUtil.addMouseDown(this.backgroundShade, this.clickHandler, null);
            }
            else {
                timeline.add(() => {
                    resetTitanSpine(this.animation);
                    SpineUtil.play(this.animation, outro);
                }, "-=0.47");
            }
        });
        this.runningTimeline = timeline;
    }
    handleClick(intro, idle, outro, win, localisedTitle) {
        if (this.runningTimeline) {
            this.runningTimeline.kill();
        }
        this.value.setText(this.formatCurrency(win), true);
        if (this.shouldLocalise()) {
            Object.values(this.localisedTitle).forEach(title => title.visible = false);
            localisedTitle.visible = true;
        }
        const curAnimation = this.animation.getTrackEntry(0).animation.name;
        if (curAnimation !== intro && curAnimation !== idle) {
            SpineUtil.play(this.animation, intro, () => {
                SpineUtil.playLoop(this.animation, idle);
            }, null, 0);
        }
        this.addHoldAndHide(gsap.timeline(), outro);
    }
    addHoldAndHide(timeline, outro) {
        timeline.add(() => {
            this.dispatchGame(SoundEvent.BIG_WIN_STOP);
            MouseUtil.setInteractive(this.backgroundShade, false);
        });
        timeline.add(() => {
            resetTitanSpine(this.animation);
            SpineUtil.play(this.animation, outro, () => this.animation.visible = false, null, 0);
            this.hideValue();
        }, "+=3");
        timeline.add(gsap.to(this.backgroundShade, { duration: 0.5, alpha: 0, delay: 1 }), "+=0.5");
        timeline.add(() => {
            this.backgroundShade.visible = false;
            this.dispatchGame(GameBigWinEvents.COMPLETE);
        });
    }
    addCountupTween(timeline, from, to) {
        const target = { value: from };
        timeline.add(gsap.to(target, {
            value: to,
            duration: 3,
            onUpdate: () => this.value.setText(this.formatCurrency(target.value), true),
            onComplete: () => this.value.setText(this.formatCurrency(to), true)
        }));
    }
    revealValue() {
        this.lightBurst.visible = true;
        SpineUtil.playLoop(this.lightBurst, "loop", 0);
        SpineUtil.play(this.lightBurst, "in", null, null, 1);
        gsap.killTweensOf(this.value);
        const timeline = gsap.timeline();
        this.value.scale.set(0);
        timeline.add(gsap.to(this.value, {
            pixi: {
                scale: 1
            },
            duration: 0.67,
            ease: "back.out(7)",
        }), 0);
        timeline.add(gsap.to(this.value, {
            pixi: {
                scale: 1.15
            },
            duration: 0.5,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut",
            yoyoEase: "power1.inOut",
        }), ">");
    }
    hideValue() {
        SpineUtil.play(this.lightBurst, "out", () => {
            this.lightBurst.visible = false;
            resetTitanSpine(this.lightBurst);
        }, null, 1);
        gsap.killTweensOf(this.value);
        gsap.to(this.value, {
            pixi: {
                scale: 0
            },
            duration: 0.5,
            ease: "back.in(7)",
            onComplete: () => {
                this.value.setText("", true);
            }
        });
    }
    shouldLocalise() {
        return !this.langManager.getLocale().getId().includes("en");
    }
    getThresholdIndexValue(win, totalStake, index) {
        return THRESHOLDS
            .map(threshold => threshold * totalStake)
            .filter(threshold => win >= threshold)[index];
    }
    getThresholdValues(win, totalStake) {
        return THRESHOLDS
            .map(threshold => threshold * totalStake)
            .filter(threshold => win >= threshold);
    }
    handleRotate(event) {
        super.handleRotate(event);
        updateResponsiveSpineSlotsChildren(this.animation, "dynamic-text-base");
    }
}
export class GameBigWinEvents {
}
GameBigWinEvents.PLAY = new EventObject("GameBigWinEvents.PLAY");
GameBigWinEvents.COMPLETE = new EventObject("GameBigWinEvents.COMPLETE");
//# sourceMappingURL=GameBigWin.js.map